import { globalProps } from "neetocommons/initializers";
import { withT } from "neetocommons/react-utils";
import { Right } from "neetoicons";
import { Dropdown, Typography } from "neetoui";

const { MenuItem } = Dropdown;

const MenuButton = withT(({ t }) => (
  <MenuItem.Button
    className="neeto-molecules-workspace-display"
    data-testid="workspace-display"
    style="text"
    suffix={<Right className="rtl:scale-x-[-1]" size={18} />}
  >
    <span className="neeto-molecules-workspace-display__content flex flex-col gap-1.5 text-start">
      <Typography
        className="neeto-molecules-workspace-display__label"
        component="span"
        style="body2"
        weight="medium"
      >
        {t("neetoMolecules.sidebar.workspace")}
      </Typography>
      {globalProps.organization?.name && (
        <Typography
          className="neeto-molecules-workspace-display__name neeto-ui-text-gray-500"
          component="span"
          style="body3"
        >
          {globalProps.organization.name}
        </Typography>
      )}
    </span>
  </MenuItem.Button>
));

export default MenuButton;
